import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReceiptionBell2"><Path d="M15 5.5H12.752V6.78027C17.8005 7.15669 21 11.3141 21 16.25V17H12.75V18.5H21V20H3V18.5H11.25V17H3V16.25C3 11.3128 6.20118 7.15485 11.252 6.78027V5.5H9V4H15V5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell2;
